var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.33333 4H21C21.7364 4 22.3333 4.59695 22.3333 5.33333C22.3333 6.06971 21.7364 6.66667 21 6.66667H2.33333C1.59695 6.66667 1 6.06971 1 5.33333C1 4.59695 1.59695 4 2.33333 4ZM2.33333 10.668H21C21.7364 10.668 22.3333 11.2649 22.3333 12.0013C22.3333 12.7377 21.7364 13.3346 21 13.3346H2.33333C1.59695 13.3346 1 12.7377 1 12.0013C1 11.2649 1.59695 10.668 2.33333 10.668ZM2.33333 17.332H21C21.7364 17.332 22.3333 17.929 22.3333 18.6654C22.3333 19.4017 21.7364 19.9987 21 19.9987H2.33333C1.59695 19.9987 1 19.4017 1 18.6654C1 17.929 1.59695 17.332 2.33333 17.332Z","fill":"#142470"}));
}

MenuInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
